import { SidebarMenuItem } from "./SidebarMenuItem";
import { SidebarMenuItemWithSub } from "./SidebarMenuItemWithSub";

export const SidebarMenuInventory = () => {
  return (
    <>
      <SidebarMenuItemWithSub
        to='/inventory'
        icon='package'
        title='คลังสินค้า'
        fontIcon='bi-layers'
      >
        <SidebarMenuItem to='/inventory/dashboard' icon='element-11' fontIcon='bi-app-indicator' title={'Dashboard'} />
        <SidebarMenuItem to='/inventory/list' icon='abstract-26' fontIcon='bi-app-indicator' title={'รายการสินค้า'} />
        <SidebarMenuItem to='/inventory/advices' icon='notification-bing' fontIcon='bi-app-indicator' title={'Advices'} />
        <SidebarMenuItem to='/inventory/transactions' icon='arrows-loop' fontIcon='bi-app-indicator' title={'Transactions'} />
        <SidebarMenuItem to='/inventory/reports' icon='document' fontIcon='bi-app-indicator' title={'รายงาน'} />
      </SidebarMenuItemWithSub>
      
      <SidebarMenuItemWithSub
        to='/asset-management'
        icon='briefcase'
        title='ทรัพย์สิน'
        fontIcon='bi-archive'
      >
        <SidebarMenuItem to='/asset-management/list' icon='abstract-26' fontIcon='bi-app-indicator' title={'รายการทรัพย์สิน'} />
        <SidebarMenuItem to='/asset-management/transactions' icon='arrows-loop' fontIcon='bi-app-indicator' title={'รายการเคลื่อนไหว'} />
        <SidebarMenuItem to='/asset-management/report' icon='document' fontIcon='bi-app-indicator' title={'รายงานทะเบียนทรัพย์สิน'} />
        <SidebarMenuItem to='/asset-management/depreciation' icon='chart-line-down' fontIcon='bi-graph-down' title={'ตารางคำนวณค่าเสื่อม'} />
      </SidebarMenuItemWithSub>
    </>
  )
}